var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHHdFlcOw(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 60,
    height: 58,
    viewBox: "0 0 60 58",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", {
    strokeWidth: 4
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    stroke: "#32239B",
    d: "M51.812 13.135c2.423 4.143 3.774 8.97 3.684 14.107-.266 15.037-12.79 27.017-27.977 26.754C12.334 53.733.24 41.328.504 26.29.736 13.146 10.334 2.34 22.887 0M40.054 2.53L39.946 2.47",
    transform: "translate(-690 -126) translate(692 128)"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#25BBFF",
    d: "M36.986 11L28.5 27.096 37.5 32",
    transform: "translate(-690 -126) translate(692 128)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHHdFlcOw);
export default __webpack_public_path__ + "static/media/HHdFlcOw.f8b0d21ada836444971e14466266b377.svg";
export { ForwardRef as ReactComponent };